<template>
  <div class="discipline-summary-modal">
    <b-modal
      id="discipline-summary-modal"
      v-model="localActive"
      size="custom-size"
      centered
      hide-footer
      hide-header
      @show="onShowModal"
      @close="localActive = false"
    >
      <svg
        class="discipline-summary-modal-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div
        class="discipline-summary-modal-header"
        :class="{
          'discipline-summary-modal-header-red': type === 'fines' || type === 'fouls',
          'discipline-summary-modal-header-green': type === 'bonuses',
        }"
      >
        <div class="discipline-summary-modal-header-title">{{ title }}</div>
        <div class="discipline-summary-modal-header-count">
          <div class="discipline-summary-modal-header-count-text">
            {{ getCountForHeader() }}
          </div>
        </div>
        <div v-if="type === 'fines' || type === 'fouls'" class="discipline-summary-modal-header-amount">
          {{ getCommonAmount() }}
          <span v-if="type === 'fines'"> {{currencyLabel}}</span>
          <span v-if="type === 'fouls'">{{ getFoulsSummaryWord() }}</span>
        </div>
      </div>
      <div class="discipline-summary-modal-search">
        <c-input
          id="discipline-summary-modal-search-input"
          v-model="searchLocal"
          class="discipline-summary-modal-search-input"
          placeholder="Поиск"
          icon="search"
          type="text"
          :clearable="true"
        />
      </div>
      <div id="discipline-summary-modal-items" class="discipline-summary-modal-items" @scroll="setShadowSummaryItems">
        <div
          v-for="(item, index) in itemsLocal"
          :key="`discipline-item-${index}`"
          class="discipline-summary-modal-items-item"
        >
          <template v-if="item.isShow">
            <div class="discipline-summary-modal-items-item-desc">{{ item.name }}</div>
            <div class="discipline-summary-modal-items-item-block">
              <div class="discipline-summary-modal-items-item-block-count">
                {{ item.count }}
              </div>
              <div v-if="item.summ !== null" class="discipline-summary-modal-items-item-block-amount">
                {{ formatAmount(item.summ) || 0 }}
                <span v-if="type === 'fines'"> {{ currencyLabel }}</span>
                <span v-if="type === 'fouls'"> б.</span>
              </div>
            </div>
          </template>
        </div>
        <div v-if="isShowSearchEmptyMessage" class="discipline-summary-modal-items-empty">Совпадений не найдено</div>
      </div>
      <div id="discipline-summary-modal-items-shadow-bottom" class="discipline-summary-modal-items-shadow-bottom"></div>
    </b-modal>
  </div>
</template>

<script>
import Input from "@/components/controls2/Input";
import { wordForm } from "@/utils/text/wordForm";

export default {
  name: "discipline-summary-modal",
  components: {
    "c-input": Input,
  },
  props: ["active", "title", "type", "amount", "items"],
  data() {
    return {
      currencyLabel: '฿',
      localActive: false,
      finesItemsLocal: [],
      violationsItemsLocal: [],
      encouragementItemsLocal: [],
      itemsLocal: [],
      searchLocal: "",
      isShowSearchEmptyMessage: false,
    };
  },

  watch: {
    localActive(value) {
      if (!value) {
        setTimeout(() => {
          this.searchLocal = "";
        }, 250);
        this.$emit("close");
      }
    },
    active(value) {
      this.localActive = value;
    },
    searchLocal(value) {
      this.itemsLocal.forEach((item) => {
        if (value.length === 0) {
          item.isShow = true;
          return;
        }
        item.isShow = item.name.toString().toLowerCase().includes(value.toString().toLowerCase());
      });

      this.isShowSearchEmptyMessage = !this.itemsLocal.some((item) => item.isShow);

      setTimeout(() => {
        this.setShadowSummaryItems();
      }, 200);
    },
  },

  mounted() {},
  async created() {
    this.getCurrencyLabel()
  },
  methods: {
    getCurrencyLabel() {
      this.$store.dispatch("personalEmployee/getCurrencyLabel").then((result) => {
        this.currencyLabel = result;
      });
    },

    setShadowSummaryItems() {
      const shadowBottomElement = document.getElementById("discipline-summary-modal-items-shadow-bottom");
      const searchElement = document.getElementById("discipline-summary-modal-search-input");
      const element = document.getElementById("discipline-summary-modal-items");
      if (element !== null) {
        if (element.scrollHeight > element.clientHeight) {
          // top shadow items
          if (element.scrollTop !== 0) {
            searchElement.classList.add("discipline-summary-modal-search-shadow-top");
          } else if (element.scrollTop === 0) {
            searchElement.classList.remove("discipline-summary-modal-search-shadow-top");
          }
          // bottom shadow items
          if (element.scrollTop + element.clientHeight !== element.scrollHeight) {
            shadowBottomElement.classList.add("discipline-summary-modal-items-shadow-bottom-active");
          } else {
            shadowBottomElement.classList.remove("discipline-summary-modal-items-shadow-bottom-active");
          }
        } else {
          searchElement.classList.remove("discipline-summary-modal-search-shadow-top");
          shadowBottomElement.classList.remove("discipline-summary-modal-items-shadow-bottom-active");
        }
      }
    },

    onShowModal() {
      this.itemsLocal = this.items.map((item) => ({
        name: item.name,
        summ: item.summ,
        count: item.count,
        isShow: true,
      }));

      setTimeout(() => {
        this.setShadowSummaryItems();
      }, 100);
    },

    closeModal() {
      this.localActive = false;
    },

    getCountForHeader() {
      let count = 0;
      this.itemsLocal.forEach((item) => {
        count += item.count;
      });
      return count;
    },

    getCommonAmount() {
      let amount = 0;
      this.itemsLocal.forEach((item) => {
        amount += item.summ;
      });
      return this.formatAmount(amount);
    },

    getFoulsSummaryWord() {
      return wordForm(this.getCommonAmount(), ["балл", "балла", "баллов"]);
    },

    formatAmount(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.discipline-summary-modal {
  position: relative;

  &-close {
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 12px;
  }

  &-header {
    display: flex;
    align-items: center;

    @media screen and (max-width: 700px) {
      margin-top: 3px;
    }

    &-title {
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;
    }

    &-count {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
      width: 28px;
      height: 20px;
      background: #f5f7fa;
      border-radius: 30px;

      &-text {
        font-weight: bold;
        font-size: 12px;
        line-height: 120%;
      }
    }

    &-amount {
      margin-left: auto;
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;

      & span {
        font-weight: 500;
        font-size: 14px;
      }
    }

    &-red {
      & .discipline-summary-modal-header-title {
        color: #ff238d;
      }

      ::v-deep & .discipline-summary-modal-header-count-text {
        color: #ff238d;
      }
    }

    &-green {
      & .discipline-summary-modal-header-title {
        color: #12c971;
      }

      ::v-deep & .discipline-summary-modal-header-count-text {
        color: #12c971;
      }
    }
  }

  &-search {
    position: relative;
    margin-top: 24px;

    &-shadow-top {
      &:before {
        content: "";
        background: -webkit-gradient(
          linear,
          left bottom,
          left top,
          color-stop(16.13%, rgba(255, 255, 255, 0)),
          color-stop(100%, #ffffff)
        );
        position: absolute;
        bottom: -50px;
        left: 0;
        z-index: 10;
        height: 30px;
        width: 100%;
      }
    }

    &-input {
      ::v-deep & .c-input-input::placeholder {
        font-style: italic;
      }

      ::v-deep & .c-input-action_clear {
        margin-top: 3px;
      }
    }
  }

  &-items {
    position: relative;
    margin-top: 21px;
    max-height: 377px;
    overflow-y: auto;
    width: calc(100% + 15px);

    @media screen and (max-width: 700px) {
      max-height: calc(100vh - 150px);
      width: calc(100% + 10px);
    }

    @include onlyExtraSmall {
      width: 100vw;
      margin-right: 0;
      margin-left: -20px;
    }

    &::-webkit-scrollbar {
      width: 4px;
      height: 100%;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-secondary;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: $color-border-alt;
      border-radius: 4px;
    }

    &-item {
      border-top: solid 1px #dfe4ef;
      border-bottom: solid 1px #dfe4ef;
      display: flex;
      align-items: center;
      margin-right: 14px;
      margin-top: -1px;
      padding: 9px 12px;

      @media screen and (max-width: 320px) {
        padding: 8px;
      }

      @include onlyExtraSmall {
        padding: 9px 20px;
        margin-right: 0;
      }

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        border-bottom: solid 1px #dfe4ef;
      }

      &-desc {
        font-size: 13px;

        @media screen and (max-width: 400px) {
          max-width: 220px;
        }
        @media screen and (max-width: 369px) {
          max-width: 180px;
        }
      }

      &-block {
        display: flex;
        justify-content: flex-end;
        max-width: 60px;
        width: 100%;
        margin-left: auto;

        &-count {
          font-weight: 500;
          font-size: 13px;
          line-height: 100%;
        }

        &-amount {
          font-weight: 500;
          font-size: 13px;
          line-height: 100%;
          margin-left: auto;
        }
      }
    }

    &-empty {
      padding: 0 12px;

      @media screen and (max-width: 320px) {
        padding: 0 8px;
      }
    }

    &-shadow-bottom {
      content: "";
      position: absolute;
      background: transparent;
      bottom: 30px;
      left: 20px;
      height: 30px;
      width: calc(100% - 50px);
      opacity: 0;
      transition: 0.2s;

      &-active {
        opacity: 1;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 16.13%, #ffffff 100%);
      }
    }
  }
}
</style>
